import { render, staticRenderFns } from "./CategoryTreeview.vue?vue&type=template&id=33d476a0"
import script from "./CategoryTreeview.vue?vue&type=script&lang=js"
export * from "./CategoryTreeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports